import { cn } from "../lib/utils";
const BookingProgress = ({ currentStep, totalSteps, onStepClick }) => {
  const baseSteps = ["Client Info", "Address", "Property Info", "Services", "Date/Time"];
  const steps = totalSteps > baseSteps.length ? [...baseSteps] : baseSteps;
  const handleStepClick = (index) => {
    if (onStepClick) {
      onStepClick(index);
    }
  };
  return (
    <div className="mb-8">
      <div className="flex justify-between">
        {steps.map((step, index) => (
          <div
            className={cn(
              "flex flex-col items-center relative w-full",
              index === steps.length - 1
                ? ""
                : "after:content-[''] after:absolute after:w-full after:h-[1px] after:border-b after:border-gray-200 after:top-4 after:left-1/2"
            )}
            key={index}
          >
            <button
              type="button"
              onClick={() => handleStepClick(index)}
              className={cn(
                "flex items-center justify-center w-8 h-8 rounded-full border-2 z-10 transition-colors cursor-pointer hover:scale-110 border-solid",
                index < currentStep
                  ? "bg-[#239d80] border-[#239d80] text-white hover:bg-[#1e8a6f]"
                  : index === currentStep
                    ? "bg-white border-[#239d80] text-[#239d80]"
                    : "bg-white border-gray-300 text-gray-300 hover:border-gray-400 hover:text-gray-400"
              )}
            >
              {index < currentStep ? "\u2713" : index + 1}
            </button>
            <button
              type="button"
              onClick={() => handleStepClick(index)}
              className={cn(
                "text-xs font-medium mt-1 text-center transition-colors cursor-pointer hover:underline",
                index === currentStep
                  ? "text-[#239d80]"
                  : index < currentStep
                    ? "text-gray-700"
                    : "text-gray-400"
              )}
            >
              {step}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
export default BookingProgress;
